import React, {useState} from 'react'
import './navigationBar.scss'
import './mobileNavigation.scss'
import {useMediaQuery} from 'react-responsive'

import {useHistory} from 'react-router-dom'
import Button from '../../components/button/Button'
import Link from './components/link/Link'

import VO_LOGO from '../../assets/VO_LOGO1.svg'
import VO_HAMBURGER from '../../assets/VO_HAMBURGER.svg'
import VO_CLOSE from '../../assets/VO_CLOSE.svg'

const navLinks = [
    {link: 'Services', path: 'services'},
    {link: 'Coverage', path: 'coverage'},
    {link: 'Contact Us', path: 'contact'},
]
const NavigationBar = () => {
    const history = useHistory()
    const [triggerHamburger, setTriggerHamburger] = useState(false)
    const SetTrigger = () => {
        console.log("here");
        setTriggerHamburger(!triggerHamburger)
    }
    const isMobile = useMediaQuery({maxWidth: 855})

    return (
        <div className="navigation__section">
            {!isMobile ? (
                <DesktopNav history={history} navLinks={navLinks}
                            SetParentTrigger={SetTrigger}/>
            ) : (
                <MobileNav history={history} SetParentTrigger={SetTrigger}
                           triggerHamburger={triggerHamburger} navLinks={navLinks}/>
            )}
        </div>
    )
}

const DesktopNav = ({history, navLinks, SetParentTrigger}) => {
    return (
        <div className="navigation__section__wrapper">
            <img onClick={() => {
                history.push('/')
            }} src={VO_LOGO} alt=""/>

            <div className="navigation__section__wrapper__links_container">
                <div className="navigation__section__wrapper__links_container__links">
                    {navLinks.map(({link, path}, key) => (
                        <Link link={link} path={path} key={key}/>
                    ))}
                </div>

                <div
                    className="navigation__section__wrapper__links_container__button_links">
                    <Button onclick={() => history.push('/price-plan')}
                            text="Plans & Pricing" type="primary"/>
                    <Button onclick={() => history.push('/about')}
                        text="About" type="tertiary" />
                </div>
            </div>
        </div>
    )
}

const MobileNav = ({history, navLinks, triggerHamburger, SetParentTrigger}) => {

    return (
        <div className="mobile_navigation__wrapper">
            <img onClick={() => {
                history.push('/');
                triggerHamburger && SetParentTrigger()
            }} src={VO_LOGO} alt=""/>
            {!triggerHamburger ? (
                <img
                    onClick={SetParentTrigger}
                    className="mobile_navigation__wrapper__links_container__hamburger"
                    src={VO_HAMBURGER}
                    alt=""
                />
            ) : (
                <img onClick={SetParentTrigger} src={VO_CLOSE} alt=""/>
            )}
            {triggerHamburger && (
                <div className="mobile_navigation__wrapper__links_container">
                    <div className="mobile_navigation__wrapper__links_container__links">
                        {navLinks.map(({link, path}, index) => (
                            <Link key={index} link={link} path={path}
                                  SetTrigger={SetParentTrigger}/>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default NavigationBar
